module.exports = __webpack_public_path__ + "91c1f252f0498678ebb440711e51f8d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/officehours/routes/JoinPage/components/JoinSessionPage/images/zoom-instructions-2.jpg
// module id = 1128
// module chunks = 0